<template>
    <div class="seckill_main">
        <will-learn layout="verticalLayout"></will-learn>
        <open-rob :robTime="19"></open-rob>
        <open-rob :robTime="22"></open-rob>
    </div>
</template>
<script>
import willLearn from './seckillComp/willLearn.vue';
import openRob from './seckillComp/openRob.vue';

// config
import appConfig from '../../appConfig';

// util
import browserHelper from '@util/browserHelper';
import deviceHelper from '@util/deviceHelper';
import appHelper from '@util/appHelper';
import wechatHelper from '@util/wechatHelper';


export default {
    data(){
        return{
          title:'限时秒杀',
        }
    },
    components:{
        willLearn,
        openRob,


    },
    methods:{
         setWechatShare : function()
        {
            let wechatShareOptions = {
                title   : appHelper.getTitle(),
                // desc    : this.desc,
                link    : location.href,
                imgUrl  : appHelper.getAppIcon() // 分享图标
            };
            wechatHelper.setShare(wechatShareOptions);
        },

    },
    mounted(){
         appHelper.setTitle(this.title);

        if (deviceHelper.isBrowser && browserHelper.isWechat)
        {
            this.setWechatShare();
        }

    }
}
</script>
<style lang="scss" scoped>
.seckill_main{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background: linear-gradient(160deg, #FF2E34 0%, #FF2617 100%);
    overflow: hidden;
    padding: 0 4% 70px;
}


</style>
